var map = {
	"./standard/Dashboard": 469,
	"./standard/Dashboard.scss": 587,
	"./standard/Dashboard.tsx": 469,
	"./standard/Declare": 467,
	"./standard/Declare.scss": 588,
	"./standard/Declare.tsx": 467,
	"./standard/Edumain": 449,
	"./standard/Edumain.scss": 589,
	"./standard/Edumain.tsx": 449,
	"./standard/Eduresult": 465,
	"./standard/Eduresult.scss": 590,
	"./standard/Eduresult.tsx": 465,
	"./standard/Exam": 466,
	"./standard/Exam.scss": 591,
	"./standard/Exam.tsx": 466,
	"./standard/Faq": 450,
	"./standard/Faq.scss": 592,
	"./standard/Faq.tsx": 450,
	"./standard/Intro": 451,
	"./standard/Intro.scss": 593,
	"./standard/Intro.tsx": 451,
	"./standard/Login": 452,
	"./standard/Login.scss": 302,
	"./standard/Login.tsx": 452,
	"./standard/Mudlogin": 453,
	"./standard/Mudlogin.scss": 454,
	"./standard/Mudlogin.tsx": 453,
	"./standard/Mudmanage": 455,
	"./standard/Mudmanage.scss": 594,
	"./standard/Mudmanage.tsx": 455,
	"./standard/Mypage": 456,
	"./standard/Mypage.scss": 595,
	"./standard/Mypage.tsx": 456,
	"./standard/Target": 468,
	"./standard/Target.scss": 614,
	"./standard/Target.tsx": 468,
	"./standard/Template": 462,
	"./standard/Template.scss": 615,
	"./standard/Template.tsx": 462,
	"./standard/edumain/Edulogin": 616,
	"./standard/edumain/Edulogin.tsx": 616,
	"./standard/edumain/Eduplay": 662,
	"./standard/edumain/Eduplay.tsx": 662,
	"./standard/edumain/Findpassword": 620,
	"./standard/edumain/Findpassword.tsx": 620,
	"./standard/edumain/Setpassword": 621,
	"./standard/edumain/Setpassword.tsx": 621,
	"./standard/exam/Bytarget": 622,
	"./standard/exam/Bytarget.tsx": 622,
	"./standard/exam/Bytemplate": 623,
	"./standard/exam/Bytemplate.tsx": 623,
	"./standard/exam/Infectionpc": 663,
	"./standard/exam/Infectionpc.tsx": 663,
	"./standard/exam/Leakfile": 664,
	"./standard/exam/Leakfile.tsx": 664,
	"./standard/exam/Pi": 660,
	"./standard/exam/Pi.tsx": 660,
	"./standard/exam/Tag": 624,
	"./standard/exam/Tag.tsx": 624,
	"./standard/login/Active": 625,
	"./standard/login/Active.tsx": 625,
	"./standard/login/Already": 626,
	"./standard/login/Already.tsx": 626,
	"./standard/login/Basic": 627,
	"./standard/login/Basic.tsx": 627,
	"./standard/login/First": 628,
	"./standard/login/First.tsx": 628,
	"./standard/login/Otp": 629,
	"./standard/login/Otp.tsx": 629,
	"./standard/login/Pwreset": 630,
	"./standard/login/Pwreset.tsx": 630,
	"./standard/login/Register": 631,
	"./standard/login/Register.tsx": 631,
	"./standard/mudlogin/Admin": 632,
	"./standard/mudlogin/Admin.tsx": 632,
	"./standard/mudlogin/Adminfirst": 633,
	"./standard/mudlogin/Adminfirst.tsx": 633,
	"./standard/mudlogin/Pwchange": 634,
	"./standard/mudlogin/Pwchange.tsx": 634,
	"./standard/mudmanage/Api": 635,
	"./standard/mudmanage/Api.tsx": 635,
	"./standard/mudmanage/Attach": 654,
	"./standard/mudmanage/Attach.tsx": 654,
	"./standard/mudmanage/Basicconf": 636,
	"./standard/mudmanage/Basicconf.tsx": 636,
	"./standard/mudmanage/Conf.scss": 98,
	"./standard/mudmanage/Edutemplate": 360,
	"./standard/mudmanage/Edutemplate.tsx": 360,
	"./standard/mudmanage/Examing": 661,
	"./standard/mudmanage/Examing.tsx": 661,
	"./standard/mudmanage/Examtemplate": 358,
	"./standard/mudmanage/Examtemplate.tsx": 358,
	"./standard/mudmanage/License": 658,
	"./standard/mudmanage/License.tsx": 658,
	"./standard/mudmanage/Log": 659,
	"./standard/mudmanage/Log.tsx": 659,
	"./standard/mudmanage/Monit": 637,
	"./standard/mudmanage/Monit.tsx": 637,
	"./standard/mudmanage/Netdata": 638,
	"./standard/mudmanage/Netdata.tsx": 638,
	"./standard/mudmanage/Phishingpage": 359,
	"./standard/mudmanage/Phishingpage.tsx": 359,
	"./standard/mudmanage/Rabbitmq": 639,
	"./standard/mudmanage/Rabbitmq.tsx": 639,
	"./standard/mudmanage/Setting": 640,
	"./standard/mudmanage/Setting.scss": 641,
	"./standard/mudmanage/Setting.tsx": 640,
	"./standard/mudmanage/Smtpconf": 642,
	"./standard/mudmanage/Smtpconf.tsx": 642,
	"./standard/mudmanage/Syncconf": 665,
	"./standard/mudmanage/Syncconf.tsx": 665,
	"./standard/mudmanage/Target": 655,
	"./standard/mudmanage/Target.tsx": 655,
	"./standard/mudmanage/User": 656,
	"./standard/mudmanage/User.tsx": 656,
	"./standard/mypage/Declare": 643,
	"./standard/mypage/Declare.tsx": 643,
	"./standard/mypage/Edu": 644,
	"./standard/mypage/Edu.tsx": 644,
	"./standard/mypage/License": 666,
	"./standard/mypage/License.scss": 645,
	"./standard/mypage/License.tsx": 666,
	"./standard/mypage/Notification": 646,
	"./standard/mypage/Notification.tsx": 646,
	"./standard/mypage/Profile": 647,
	"./standard/mypage/Profile.scss": 648,
	"./standard/mypage/Profile.tsx": 647,
	"./standard/mypage/Share": 667,
	"./standard/mypage/Share.scss": 649,
	"./standard/mypage/Share.tsx": 667,
	"./standard/mypage/Smtp": 650,
	"./standard/mypage/Smtp.tsx": 650,
	"./standard/template/Edutemplate": 651,
	"./standard/template/Edutemplate.tsx": 651,
	"./standard/template/Examtemplate": 652,
	"./standard/template/Examtemplate.tsx": 652,
	"./standard/template/Phishingpage": 653,
	"./standard/template/Phishingpage.tsx": 653,
	"./standard/template/Quiz": 657,
	"./standard/template/Quiz.tsx": 657
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1115;